// test41
(41 && 0);
